import { Flex, Text } from "@wayflyer/flyui";
import type { ReactNode } from "react";
import { useIntl } from "react-intl";
import { getFormattedMinEligibleRevenue, isSupportedCurrency } from "shared-utils";

import type { FormattedFundingApplicationScreen } from "../../../queries/funding-application/queries";
import { MESSAGES } from "../message-definitions";

export const RevenueLetDown = ({
  eligibilityLink,
  fundingApplication,
}: {
  eligibilityLink: ReactNode;
  fundingApplication: FormattedFundingApplicationScreen;
}) => {
  const intl = useIntl();
  const revenueCurrency = fundingApplication.reportedRevenueCurrency;
  const currency = revenueCurrency && isSupportedCurrency(revenueCurrency) ? revenueCurrency : "USD";

  const minRevenueAmount = getFormattedMinEligibleRevenue(intl, currency);
  return (
    <Flex direction="column" gap="4">
      <Text>
        {intl.formatMessage(MESSAGES.letDownSubHeading, {
          minRevenueAmount,
        })}
      </Text>
      <Text>{eligibilityLink}</Text>
    </Flex>
  );
};
